export enum Transition {
	fast = "0.1s ease",
	hover = "0.25s ease",
	input = "0.25s ease",
	slide = "0.4s ease",
	slow = "1s ease",
}
